import ScribbleClient from '@plangrid/scribble-client';
import {
  RawApiClient,
  serviceOriginRequestTransformer,
  throwNon200ResponseTransformer,
  parseBodyAsJsonResponseTransformer,
} from '@plangrid-private/web-api-clients';

import {
  Env,
  ENVS,
  getEnv,
  getRegion,
  Region,
  REGIONS,
} from '@adsk/acs-sc-web-platform-api';

type RegionConfig = {
  [region in Region]: {
    [env in Env]: string | null; // null means not configured
  };
};

// TODO: Can be folded into the main config once APAC alias is removed
const ausConfig = {
  [ENVS.PRODUCTION]: 'https://io.plangrid.com.au',
  [ENVS.STAGING]: 'https://io.aus-stg.planfront.net',
  [ENVS.QA]: null,
};

const regionConfig: RegionConfig = {
  [REGIONS.APAC]: ausConfig,
  [REGIONS.AUS]: ausConfig,
  [REGIONS.EMEA]: {
    [ENVS.PRODUCTION]: 'https://io.plangrid.be',
    [ENVS.STAGING]: null,
    [ENVS.QA]: null,
  },
  [REGIONS.US]: {
    [ENVS.PRODUCTION]: 'https://io.plangrid.com',
    [ENVS.STAGING]: 'https://plangrid-c-api-dispatcher-test.planfront.net',
    [ENVS.QA]: 'https://plangrid-c-api-dispatcher-dev.planfront.net',
  },
};

const scribbleOrigin: string = (() => {
  const region = getRegion();
  const env = getEnv();

  const endpoint = regionConfig[region][env];

  if (!endpoint) {
    console.error(
      `Scribble: env ${env} is not configured for region ${region}`,
    );
    return `scribble-${region}-${env}-not-configured`;
  }

  return endpoint;
})();

const rawApiClient = new RawApiClient({
  requestTransformers: [
    serviceOriginRequestTransformer('scribble', scribbleOrigin),
  ],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
  ],
});

const scribbleClient = new ScribbleClient(rawApiClient);

export const getSurfaceAnnotations = (
  projectUid: string,
  surfaceUid: string,
  params?: {
    limit?: number;
    skip?: number;
  },
) =>
  scribbleClient.getSurfaceAnnotations(projectUid, surfaceUid, params, {
    getAll: true,
  });

export const getBaseEntityAnnotations = (
  projectUid: string,
  baseEntityUid: string,
) => scribbleClient.getBaseEntityAnnotations(projectUid, baseEntityUid);

export const getSurface = (projectUid: string, surfaceUid: string) =>
  scribbleClient.getSurface(projectUid, surfaceUid);

export default scribbleClient;
